/**
 * An array of objects that communicate the type, reason, and access of data that is used.
 * This application does not collect any user data.
 * @type {Array<Object>}
 */
export const collectedData = [];
